// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.charts-container{
    width:100%;
    justify-content: center;
    min-width: 10em;
}
.chart-header{
    color: black;
    font-size: 0.8em;
    font-weight: bold;
    padding: 0.75em;
}
.selected-machine {
    font-weight: normal; /* Set font weight to normal */
    color: #555; /* Set text color */
  }

.chart-template{
    width: 100%;
}
  `, "",{"version":3,"sources":["webpack://./src/components/view-charts/viewCharts.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,uBAAuB;IACvB,eAAe;AACnB;AACA;IACI,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,mBAAmB,EAAE,8BAA8B;IACnD,WAAW,EAAE,mBAAmB;EAClC;;AAEF;IACI,WAAW;AACf","sourcesContent":[".charts-container{\n    width:100%;\n    justify-content: center;\n    min-width: 10em;\n}\n.chart-header{\n    color: black;\n    font-size: 0.8em;\n    font-weight: bold;\n    padding: 0.75em;\n}\n.selected-machine {\n    font-weight: normal; /* Set font weight to normal */\n    color: #555; /* Set text color */\n  }\n\n.chart-template{\n    width: 100%;\n}\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
